import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import BILINGUALPROJECT1 from"../../assets/RealEnglishImages/BILINGUALPROJECT1.png"
import BILINGUALPROJECT2 from"../../assets/RealEnglishImages/BILINGUALPROJECT2.png"
import BilingualProjectImages from './BilingualProjectImages';
const BilingualProject = () => {
    return (
        <React.Fragment>
            <section className="section " id="BilingualProject">
            <Container>
                <Row className="justify-content-center">
                    <Col xs={12}>
                        <div className="text-center">
                            <h2 className="display-6 fw-bold text-success mb-5 bilingual-header row">
                            <div className="col-12 col-lg-3 d-flex pb-4 pb-lg-0 justify-content-center justify-content-lg-end">
                                    <img src={BILINGUALPROJECT2} className="card-logo" alt="logo start" height="120"/>
                                </div>
                                <div className="col-12 col-lg-6 d-flex align-items-center justify-content-center">
                                    <span className='text-nowrap'>The Bilingual Project</span>
                                </div>
                                <div className="col-12 col-lg-3 pt-4 pt-lg-0 d-flex justify-content-center justify-content-lg-start">
                                    <img src={BILINGUALPROJECT1} className="card-logo" alt="logo end" height="120"/>
                                </div>
                            </h2>
                        </div>
                    </Col>
                    <Col lg={8} sm={10}>  
                   

                     
                    <div className="text-center p-4 ">
                  

                        <p className="lead lh-base">
                        For our youngest learners (ages 3-6), The Bilingual Project
                        offers a fully immersive experience where children acquire
                        English naturally, just like a first language.
                        </p>
                        <p className="lead lh-base">
                        Through <span className="text-primary">music</span>,{" "}
                        <span className="text-success">storytelling</span>, and{" "}
                        <span className="text-danger">interactive play</span>, they
                        absorb English effortlessly and begin communicating with
                        confidence.
                        </p>
                        <div className="d-flex justify-content-center mt-4">
                        <div className="p-3 text-center">
                            <i className="mdi mdi-music-note fs-36 text-primary"></i>
                            <p className="mt-2">Music & Rhythm</p>
                        </div>
                        <div className="p-3 text-center">
                            <i className="mdi mdi-book-open-variant fs-36 text-success"></i>
                            <p className="mt-2">Storytelling</p>
                        </div>
                        <div className="p-3 text-center">
                            <i className="mdi mdi-puzzle fs-36 text-danger"></i>
                            <p className="mt-2">Interactive Play</p>
                        </div>
                        </div>
                        <p className="lead lh-base mt-3">
                         At{" "}
                        <strong className="text-info">Real English Academy</strong>,
                        we focus on real communication for real life. Our students
                        don’t just memorize English—they use it naturally and
                        confidently in everyday situations.
                        </p>
                        <p className="lead lh-base">
                        Join us and experience a truly immersive way to learn!
                        </p>
                    </div>
                    </Col>
                </Row>
            </Container>
            <Container>
                <Row>
                    <BilingualProjectImages/>
                </Row>
            </Container>
            </section>
        </React.Fragment>
    );
};

export default BilingualProject;